import { render } from "./BatchFailedPaymentsRemovalConfirmationDialog.vue?vue&type=template&id=605b7695"
import script from "./BatchFailedPaymentsRemovalConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./BatchFailedPaymentsRemovalConfirmationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__